import { render, staticRenderFns } from "./PerimeterTab.vue?vue&type=template&id=c791c734&scoped=true"
import script from "./PerimeterTab.vue?vue&type=script&lang=js"
export * from "./PerimeterTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c791c734",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c791c734')) {
      api.createRecord('c791c734', component.options)
    } else {
      api.reload('c791c734', component.options)
    }
    module.hot.accept("./PerimeterTab.vue?vue&type=template&id=c791c734&scoped=true", function () {
      api.rerender('c791c734', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/views/rh/gestion/campaign/Evaluate/partials/tabs/PerimeterTab.vue"
export default component.exports